import { lazy, Suspense } from "react";
import { useLocation } from "react-router-dom";
import { langFromPath } from "@/i18n/lang";

const DiagnosticChatbot = lazy(() => import("@/components/DiagnosticChatbot"));

/** The diagnostic chat is Hebrew-only; on /en pages the English WhatsApp button takes its place. */
const HebrewOnlyChatbot = () => {
  const { pathname } = useLocation();
  if (langFromPath(pathname) !== "he") return null;
  return (
    <Suspense fallback={null}>
      <DiagnosticChatbot />
    </Suspense>
  );
};

export default HebrewOnlyChatbot;
